import { forwardRef, Module } from '@nestjs/common';
import { WelfareController } from './welfare.controller';
import { WelfareService } from './welfare.service';
import { WelfareEntity} from './welfare.entity';
import { TypeOrmModule } from '@nestjs/typeorm';
import { WelfareStatusEntity } from './welfare-status.entity';
import { WelfareFilesEntity } from './welfare-files.entity';
import { ProfileModule } from '../profile/profile.module';
import { VillageModule } from '../village/village.module';
import { NotificationsEntity } from '../notifications/notifications.entity';
@Module({
  imports: [
    TypeOrmModule.forFeature([WelfareEntity, WelfareStatusEntity,WelfareFilesEntity,NotificationsEntity]),
    forwardRef(()=>ProfileModule),VillageModule,
  ],
  controllers: [WelfareController],
  providers: [WelfareService],
  exports:[WelfareService]
})
export class WelfareModule {}
